import React from 'react';
import { connect } from 'react-redux';
import modeType from '../../constants/ModeConstants';
import platformDetection from '../utils/PlatformDetection';
import properties from '../../constants/Properties';
import mouseUtils from '../utils/MouseUtils';
import { ListItemRenderer } from '../accordion/ListItemRenderer';
import { ScrollableComponent } from '../menus/ScrollableComponent';
import { ClipartSelectorListNew } from '../menus/ClipartSelectorListNew';
import apiServiceUtils from '../utils/ApiServiceUtils';
import apiService from '../../services/ApiService';
import appParameters from '../utils/AppParameters';
import configuration from '../../constants/Configuration';
import masterUniverseUtils from '../utils/MasterUniverseUtils';
import storeManager from '../../store/StoreManager';
import { SoundItemRenderer } from '../../components/menus/SoundItemRenderer';
import videoClipartParserJSON from '../accordion/clipartUtils/VideoClipartParserJSON';
import locales from '../../locales/LocalesManager';
import { changeAudioTabIndex, changeCartoonistTabIndex, changeContextMode } from '../../actions/MenuActions';
import textSizeUtils from '../utils/TextSizeUtils';
import populateMediaFilesUtils from '../utils/PopulateMediaFilesUtils';
import clipartParserJSONNew from '../accordion/clipartUtils/ClipartParserJSONNew';
import { OnOffToggleButton } from '../menus/OnOffToggleButton';
import audioToolUtils from '../audioTool/utils/AudioToolUtils';
import videoUtils from '../utils/VideoUtils';
import cartIcons from '../../styles/fonts/cartoonistIcons.css';
import playController from '../utils/PlayController';
import moodsUtils from '../utils/MoodsUtils';
import mindMapUtils from '../utils/MindMapUtils';

const ClipartList = React.createClass({
    getInitialState() {
        return {
            currentPage: 0,
            oldElements: [],
            dataProvider: this.props.dataProvider
        };
    },
    componentWillReceiveProps: function(nextProps) {
        if (this.props.searchObject != nextProps.searchObject || this.props.dataProvider != nextProps.dataProvider) {
            masterUniverseUtils.scrollPosition = 0;

            this.setState({
                currentPage: 0,
                dataProvider: nextProps.dataProvider
            });
        }
    },
    uploadNewPage(scrollTop) {
        if (Math.abs(scrollTop - masterUniverseUtils.scrollPosition) < 40)
            return;

        masterUniverseUtils.scrollPosition = scrollTop;

        var searchObject = this.props.searchObject;

        if (!searchObject)
            return;

        apiService.searchNewContent(searchObject.locale, searchObject.category, searchObject.searchText, this.state.currentPage + 1, searchObject.pageSize)
            .then(response => {
                if (!response || response.length < 1) {
                    this.setState({
                        currentPage: this.state.currentPage + 1
                    });
                } else {
                    var newPageItems = clipartParserJSONNew.parseSearchItems(response, searchObject.searchText, searchObject.category)
                    this.setState({
                        dataProvider: this.state.dataProvider.concat(newPageItems),
                        currentPage: this.state.currentPage + 1
                    });
                }
            });
    },
    render() {
        let items = this.state.dataProvider ? this.state.dataProvider : this.props.dataProvider;
        var isLoading = this.props.isLoading;

        if (isLoading) {
            var preloaderStyle = {
                position: 'relative',
                top: this.props.top,
                fontSize: '15px',
                marginLeft: this.props.width/2 - 15
            };

            return (
                <div style={preloaderStyle}>
                    <i className={'fa fa-spinner fa-pulse fa-2x'}/>
                </div>
            );
        } else {
            if (this.props.isSearch && this.props.noHits) {
                var divStyle = {
                    position: 'relative',
                    top: this.props.top,
                    width: this.props.width,
                    textAlign: 'center',
                    fontSize: '15px'
                };

                return (
                    <div style={divStyle}>
                        {locales.getCaption('searchNoHits', 'other')}
                    </div>
                );
            }
        }

        const paddingTop = 12;
        const paddingLeft = 3;
        var componentProperties = {};
        let elements = [];
        let i;
        var showBackgroundsButton = false;

        for (i=0; i<items.length; i++) {
            const item = items[i];
            var isBackground = false;

            if (item.isBackground || (item.logicalName && item.logicalName.indexOf('background') != -1) || (item.href && item.href.indexOf('background') != -1)) {
                isBackground = true;
                showBackgroundsButton = true;
            }

            var key = 'item_' + new Date().getTime() + '_' + i;

            elements.push(<ListItemRenderer item={item} key={key} isBackground={isBackground} usePagination={true} index={i} isSearch={true} parentWidth={this.props.width}/>);
        }

        componentProperties.paddingTop = paddingTop;
        componentProperties.paddingLeft = paddingLeft;
        componentProperties.width = this.props.width;
        componentProperties.top = this.props.top;
        componentProperties.displayState = 'inline-block';
        componentProperties.height = this.props.height;
        componentProperties.elements = elements;

        componentProperties.usePagination = true;
        componentProperties.uploadNewPage = this.uploadNewPage;

        var onOffButton;

        if (this.props.isBackgroundList && showBackgroundsButton) {
            var topGap = 0;
            var bottomGap = 0;
            var onOffButtonProperties = {};

            onOffButtonProperties.topPosition = componentProperties.top + topGap;
            onOffButtonProperties.leftPosition = properties.MY_MEDIA_FILES_GAP;
            onOffButtonProperties.trackWidth = properties.TOGGLE_TRACK_WIDTH;
            onOffButtonProperties.trackHeight = properties.TOGGLE_TRACK_HEIGHT;
            onOffButtonProperties.thumbHref = appParameters.RESOURCES_LOCATION() + 'assets/sliderThumb.png';
            onOffButtonProperties.thumbSize = properties.TOGGLE_THUMB_SIZE;
            onOffButtonProperties.dispatch = this.props.dispatch;
            onOffButtonProperties.width = properties.BROWSER_WIDTH - 2 * properties.MY_MEDIA_FILES_GAP;

            onOffButtonProperties.isBackgroundElement = true;
            onOffButtonProperties.useBackgroundAsImage = this.props.useBackgroundAsImage;

            onOffButton = <OnOffToggleButton properties={onOffButtonProperties} dispatch={this.props.dispatch}/>;

            var toggleButtonHeight = onOffButtonProperties.thumbSize + topGap + bottomGap;

            componentProperties.top = componentProperties.top + toggleButtonHeight;
            componentProperties.height = componentProperties.height - toggleButtonHeight;
        }

        return (
            <div>
                {onOffButton}
                <ScrollableComponent componentProperties={componentProperties}/>
            </div>
        );
    }
});

const MediaList = React.createClass({
    getInitialState() {
        return {
            currentPage: 0,
            dataProvider: this.props.dataProvider,
            elements: this.getCurrentElements(this.props.dataProvider, 0)
        };
    },
    componentWillReceiveProps: function(nextProps) {
        if (this.props.dataProvider != nextProps.dataProvider) {
            masterUniverseUtils.scrollPosition = 0;

            this.setState({
                currentPage: 0,
                dataProvider: nextProps.dataProvider,
                elements: this.getCurrentElements(nextProps.dataProvider, 0)
            });
        }
    },
    uploadNewPage(scrollTop) {
        if (Math.abs(scrollTop - masterUniverseUtils.scrollPosition) < 40)
            return;

        masterUniverseUtils.scrollPosition = scrollTop;

        this.setState({
            elements: this.getCurrentElements(this.state.dataProvider, this.state.currentPage + 1),
            currentPage: this.state.currentPage + 1
        });
    },
    getCurrentElements(allElements, page) {
        var hitsPerPage = 50;
        var maxIndex = hitsPerPage * (page + 1);
        var items = [];

        for (var i=0; i<allElements.length; i++) {
            if (i < maxIndex)
                items.push(allElements[i]);
            else
                break;
        }

        return items;
    },
    render() {
        if (this.state == undefined || this.state.elements == undefined)
            return (<div/>);

        let items = this.state.elements;
        var isLoading = this.props.isLoading;

        if (isLoading) {
            var preloaderStyle = {
                position: 'relative',
                top: this.props.top,
                fontSize: '15px',
                marginLeft: this.props.width/2 - 15
            };

            return (
                <div style={preloaderStyle}>
                    <i className={'fa fa-spinner fa-pulse fa-2x'}/>
                </div>
            );
        } else {
            if (this.props.isSearch && this.props.noHits) {
                var divStyle = {
                    position: 'relative',
                    top: this.props.top,
                    width: this.props.width,
                    textAlign: 'center',
                    fontSize: '15px'
                };

                return (
                    <div style={divStyle}>
                        {locales.getCaption('searchNoHits', 'other')}
                    </div>
                );
            }
        }

        if (!platformDetection.isIOSApp() && !mindMapUtils.isMindMapMode()) {
            if (this.props.isMyMedia)
                items = [{isUploadButton: true}].concat(items);
        }

        const paddingTop = 12;
        const paddingLeft = 3;
        var componentProperties = {};
        let elements = [];
        let i;

        for (i=0; i<items.length; i++) {
            const item = items[i];
            var key = 'item_' + new Date().getTime() + '_' + i;

            elements.push(<ListItemRenderer item={item} key={key} isFrame={this.props.isFrame} isBackground={this.props.isBackground} isMedia={this.props.isMedia} isVideo={this.props.isVideo} usePagination={true} index={i} isSearch={true} parentWidth={this.props.width}/>);
        }

        componentProperties.paddingTop = paddingTop;
        componentProperties.paddingLeft = paddingLeft;
        componentProperties.width = this.props.width;
        componentProperties.top = this.props.top;
        componentProperties.displayState = 'inline-block';
        componentProperties.height = this.props.height;
        componentProperties.elements = elements;

        componentProperties.usePagination = true;
        componentProperties.uploadNewPage = this.uploadNewPage;

        var onOffButton;

        if (this.props.isBackgroundList && !mindMapUtils.isMindMapMode()) {
            var topGap = 0;
            var bottomGap = 0;
            var onOffButtonProperties = {};

            onOffButtonProperties.topPosition = componentProperties.top + topGap;
            onOffButtonProperties.leftPosition = properties.MY_MEDIA_FILES_GAP;
            onOffButtonProperties.trackWidth = properties.TOGGLE_TRACK_WIDTH;
            onOffButtonProperties.trackHeight = properties.TOGGLE_TRACK_HEIGHT;
            onOffButtonProperties.thumbHref = appParameters.RESOURCES_LOCATION() + 'assets/sliderThumb.png';
            onOffButtonProperties.thumbSize = properties.TOGGLE_THUMB_SIZE;
            onOffButtonProperties.dispatch = this.props.dispatch;
            onOffButtonProperties.width = properties.BROWSER_WIDTH - 2 * properties.MY_MEDIA_FILES_GAP;

            if (this.props.isMedia) {
                onOffButtonProperties.isMediaFilesElement = true;

                if (this.props.isVideo) {
                    onOffButtonProperties.useVideoAsBackground = this.props.useVideoAsBackground;
                    onOffButtonProperties.isVideo = true;
                }
                else {
                    onOffButtonProperties.useImageAsBackground = this.props.useImageAsBackground;
                    onOffButtonProperties.isVideo = false;
                }
            } else {
                onOffButtonProperties.isBackgroundElement = true;
                onOffButtonProperties.isFrame = true;
                onOffButtonProperties.useFrameAsImage = this.props.useFrameAsImage;
            }

            onOffButton = <OnOffToggleButton properties={onOffButtonProperties} dispatch={this.props.dispatch}/>;

            var toggleButtonHeight = onOffButtonProperties.thumbSize + topGap + bottomGap;

            componentProperties.top = componentProperties.top + toggleButtonHeight;
            componentProperties.height = componentProperties.height - toggleButtonHeight;
        }

        return (
            <div>
                {onOffButton}
                <ScrollableComponent componentProperties={componentProperties}/>
            </div>
        );
    }
});

const VideoThemesList = React.createClass({
    getInitialState() {
        return {
            currentPage: 0,
            oldElements: [],
            dataProvider: this.props.dataProvider
        };
    },
    componentWillReceiveProps: function(nextProps) {
        if (this.props.searchObject != nextProps.searchObject || this.props.dataProvider != nextProps.dataProvider) {
            masterUniverseUtils.scrollPosition = 0;

            this.setState({
                currentPage: 0,
                dataProvider: nextProps.dataProvider
            });
        }
    },
    uploadNewPage(scrollTop) {
        if (Math.abs(scrollTop - masterUniverseUtils.scrollPosition) < 40)
            return;

        masterUniverseUtils.scrollPosition = scrollTop;

        var searchObject = this.props.searchObject;

        if (!searchObject)
            return;

        apiService.searchVideo(searchObject.locale, searchObject.searchText,this.state.currentPage + 1, searchObject.pageSize)
            .then(response => {
                if (!response || response.length < 1) {
                    this.setState({
                        currentPage: this.state.currentPage + 1
                    });
                } else {
                    var newPageItems = videoClipartParserJSON.parseSearchItems(response)
                    this.setState({
                        dataProvider: this.state.dataProvider.concat(newPageItems),
                        currentPage: this.state.currentPage + 1
                    });
                }
            });
    },
    render() {
        let items = this.state.dataProvider ? this.state.dataProvider : this.props.dataProvider;
        var isLoading = this.props.isLoading;

        if (isLoading) {
            var preloaderStyle = {
                position: 'relative',
                top: this.props.top,
                fontSize: '15px',
                marginLeft: this.props.width/2 - 15
            };

            return (
                <div style={preloaderStyle}>
                    <i className={'fa fa-spinner fa-pulse fa-2x'}/>
                </div>
            );
        } else {
            if (this.props.isSearch && this.props.noHits) {
                var divStyle = {
                    position: 'relative',
                    top: this.props.top,
                    width: this.props.width,
                    textAlign: 'center',
                    fontSize: '15px'
                };

                return (
                    <div style={divStyle}>
                        {locales.getCaption('searchNoHits', 'other')}
                    </div>
                );
            }
        }

        const paddingTop = 12;
        const paddingLeft = 3;
        var componentProperties = {};
        let elements = [];
        let i;
        var showBackgroundsButton = false;

        for (i=0; i<items.length; i++) {
            const item = items[i];
            var key = 'item_' + new Date().getTime() + '_' + i;

            elements.push(<ListItemRenderer item={item} key={key} isVideo={true} usePagination={true} index={i} isSearch={true} parentWidth={this.props.width}/>);
        }

        componentProperties.paddingTop = paddingTop;
        componentProperties.paddingLeft = paddingLeft;
        componentProperties.width = this.props.width;
        componentProperties.top = this.props.top;
        componentProperties.displayState = 'inline-block';
        componentProperties.height = this.props.height;
        componentProperties.elements = elements;

        componentProperties.usePagination = true;
        componentProperties.uploadNewPage = this.uploadNewPage;

        var onOffButton;
        var topGap = 0;
        var bottomGap = 0;
        var onOffButtonProperties = {};

        onOffButtonProperties.topPosition = componentProperties.top + topGap;
        onOffButtonProperties.leftPosition = properties.MY_MEDIA_FILES_GAP;
        onOffButtonProperties.trackWidth = properties.TOGGLE_TRACK_WIDTH;
        onOffButtonProperties.trackHeight = properties.TOGGLE_TRACK_HEIGHT;
        onOffButtonProperties.thumbHref = appParameters.RESOURCES_LOCATION() + 'assets/sliderThumb.png';
        onOffButtonProperties.thumbSize = properties.TOGGLE_THUMB_SIZE;
        onOffButtonProperties.dispatch = this.props.dispatch;
        onOffButtonProperties.width = properties.BROWSER_WIDTH - 2 * properties.MY_MEDIA_FILES_GAP;

        onOffButtonProperties.isMediaFilesElement = true;
        onOffButtonProperties.useVideoAsBackground = this.props.useVideoAsBackground;
        onOffButtonProperties.isVideo = true;

        onOffButton = <OnOffToggleButton properties={onOffButtonProperties} dispatch={this.props.dispatch}/>;

        var toggleButtonHeight = onOffButtonProperties.thumbSize + topGap + bottomGap;

        componentProperties.top = componentProperties.top + toggleButtonHeight;
        componentProperties.height = componentProperties.height - toggleButtonHeight;

        return (
            <div>
                {onOffButton}
                <ScrollableComponent componentProperties={componentProperties}/>
            </div>
        );
    }
});

const AudioList = React.createClass({
    render() {
        if (this.props.isSearch && this.props.noHits) {
            var divStyle = {
                position: 'relative',
                top: this.props.top,
                width: this.props.width,
                textAlign: 'center',
                fontSize: '15px'
            };

            return (
                <div style={divStyle}>
                    {locales.getCaption('searchNoHits', 'other')}
                </div>
            );
        }

        var elements = [];
        var i;
        var item;

        for (i=0; i<this.props.dataProvider.length; i++) {
            item = this.props.dataProvider[i];
            var key = 'item_' + new Date().getTime() + '_' + i;

            elements.push(<SoundItemRenderer accordionWidth={this.props.accordionWidth} index={i} key={key} dispatch={this.props.dispatch} value={item} isMediaSound={this.props.isMediaSound}/>);
        }

        var componentProperties = {};
        componentProperties.paddingTop = 0;
        componentProperties.paddingLeft = 0;
        componentProperties.width = this.props.accordionWidth;
        componentProperties.height = this.props.height;
        componentProperties.top = this.props.top;
        componentProperties.displayState = 'block';
        componentProperties.elements = elements;
        componentProperties.scrollHeight = (properties.SOUND_ITEM_HEIGHT + properties.SOUND_ITEMS_GAP) * elements.length;

        return (
            <ScrollableComponent componentProperties={componentProperties}/>
        );
    }
});

const CartoonistTabElement = React.createClass({
    getInitialState () {
        return {
            isOver: false
        };
    },
    onMouseIn () {
        this.setState({
            isOver: true
        });
    },
    onMouseOut () {
        this.setState({
            isOver: false
        });
    },
    getCorrectIndex() {
        let index = this.props.index;

        if (mindMapUtils.isMindMapMode()) {
            if (index === 3) // 4th element should be Effects
                index = 5;

            if (index === 4) // last tab should be MyImages
                index = 7;
        }

        return index;
    },
    onClick(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        const dispatch = storeManager.getStore().dispatch;
        let tabIndex = this.props.cartoonistTabIndex;
        let index = this.getCorrectIndex();

        if (index != tabIndex)
            dispatch(changeCartoonistTabIndex(index));

        if (platformDetection.isIOS())
            return;

        setTimeout(function() {
            var element = document.getElementById('closeButton');

            if (element)
                element.focus();
        }.bind(this), 100);
    },
    render() {
        var tabHeight = 50;
        let topPosition = tabHeight * this.props.index;
        var buttonColor;
        var icon;
        var color;
        var tabIndex = this.props.cartoonistTabIndex;
        let index = this.getCorrectIndex();

        if (index == tabIndex) {
            buttonColor = '#434343';
            color = 'white';
        } else {
            if (this.state.isOver == true) {
                buttonColor = '#F7F7F7';
                color = '#2299D6';
            } else {
                buttonColor = 'white';
                color = '#434343';
            }
        }

        const tabStyle = {
            position: 'absolute',
            backgroundColor: buttonColor,
            width: this.props.width,
            height: tabHeight,
            top: topPosition,
            userSelect: 'none',
            WebkitUserSelect: 'none',
            userDrag: 'none',
            margin: 0,
            padding: 0,
            boxSizing: 'initial',
            fontSize: 'initial',
            borderStyle: 'none',
            textAlign: 'left'
        };

        const spanStyle = {
            position: 'absolute',
            top: 17,
            left: 40,
            color: color,
            fontSize: 15,
            width: this.props.width - 50,
            whiteSpace: 'nowrap',
            display: 'inline-block',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            cursor: 'default'
        };

        let text;

        switch (index) {
            case 0: {
                text = locales.getCaption('SearchAll', 'other');
                icon = 'cart-search';
                break;
            }
            case 1: {
                text = locales.getCaption('SearchProps', 'other');
                icon = 'cart-football';
                break;
            }
            case 2: {
                text = locales.getCaption('SearchCharacters', 'other');
                icon = 'cart-character';
                break;
            }
            case 3: {
                text = locales.getCaption('SearchBackgrounds', 'other');
                icon = 'cart-background';
                break;
            }
            case 4: {
                text = locales.getCaption('SearchFrames', 'other');
                icon = 'cart-frame';
                break;
            }
            case 5: {
                text = locales.getCaption('SearchEffects', 'other');
                icon = 'cart-effect';
                break;
            }
            case 6: {
                text = locales.getCaption('SearchThemes', 'other');
                icon = 'cart-themes';
                break;
            }
            case 7: {
                text = locales.getCaption('SearchMyImages', 'other');
                icon = 'cart-camera';
                break;
            }
            case 8: {
                text = locales.getCaption('SearchMyVideos', 'other');
                icon = 'cart-video-camera';
                break;
            }
            case 9: {
                text = locales.getCaption('SearchThemeVideos');
                icon = 'cart-video-play';
                break;
            }
            case 10: {
                text = locales.getCaption('SearchAudios', 'other');
                icon = 'cart-music';
                break;
            }
        }
        const iconStyle = {
            position: 'absolute',
            top: 17,
            left: 15,
            fontSize: 18,
            color: color
        };

        return (
            <button aria-label={text} style={tabStyle} onMouseOver={this.onMouseIn} onMouseOut={this.onMouseOut} onClick={this.onClick} onTouchEnd={this.onClick}>
                <i style={iconStyle} className={cartIcons[icon]}></i>
                <span style={spanStyle}>{text}</span>
            </button>
        );
    }
});

const AudioTabElement = React.createClass({
    getInitialState() {
        return {
            isOver: false
        };
    },
    onMouseIn() {
        this.setState({
            isOver: true
        });
    },
    onMouseOut() {
        this.setState({
            isOver: false
        });
    },
    onClick(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        const dispatch = storeManager.getStore().dispatch;
        var tabIndex = this.props.audioTabIndex;

        if (this.props.index == tabIndex)
            dispatch(changeAudioTabIndex(-1));
        else
            dispatch(changeAudioTabIndex(this.props.index));
    },
    render() {
        let topPosition = properties.BROWSER_BUTTON_HEIGHT * this.props.index + 1;
        var buttonColor;
        var textColor;
        var icon;
        var iconColor;
        var tabIndex = this.props.audioTabIndex;

        if (this.props.index == tabIndex) {
            buttonColor = properties.BROWSER_SELECTED_COLOR;
            textColor = '#F7F7F7';
            icon = 'fa fa-angle-down';
            iconColor = 'white';
        }
        else {
            icon = 'fa fa-angle-right';
            iconColor = 'black';

            if (this.state.isOver == true) {
                buttonColor = properties.BROWSER_HOVER_COLOR;
                textColor = '#2299D6';
            } else {
                buttonColor = properties.BROWSER_COLOR;
                textColor = '#000000';
            }
        }

        const tabStyle = {
            position: 'absolute',
            backgroundColor: buttonColor,
            width: this.props.accordionWidth,
            height: properties.BROWSER_BUTTON_HEIGHT - 1,
            paddingLeft: properties.BROWSER_LEFT_PADDING,
            top: topPosition,
            color: 'white',
            userSelect: 'none',
            WebkitUserSelect: 'none',
            userDrag: 'none',
            margin: 0,
            paddingTop: 0,
            paddingRight: 0,
            paddingBottom: 0,
            boxSizing: 'initial',
            fontSize: 'initial',
            borderStyle: 'none',
            textAlign: 'left'
        };

        const spanStyle = {
            position: 'absolute',
            top: 5,
            color: textColor,
            fontSize: 15,
            width: this.props.accordionWidth - 3 * properties.BROWSER_LEFT_PADDING,
            whiteSpace: 'nowrap',
            display: 'inline-block',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            cursor: 'default'
        };

        const iconStyle = {
            position: 'absolute',
            top: 6,
            right: properties.BROWSER_LEFT_PADDING + properties.BROWSER_ICON_RIGHT_PADDING,
            color: iconColor
        };

        var text;

        if (this.props.index == 0)
            text = locales.getCaption('StorySoundTab', 'music');
        else
            text = locales.getCaption('SlideSoundTab', 'music');

        return (
            <button aria-label={text} style={tabStyle} onMouseOver={this.onMouseIn} onMouseOut={this.onMouseOut} onClick={this.onClick} onTouchEnd={this.onClick}>
                <span style={spanStyle}>{text}</span>
                <i style={iconStyle} className={icon}></i>
            </button>
        );
    }
});

const SearchMenuContent = React.createClass({
    getInitialState () {
        return {
            isOver: false,
            dataProvider: [],
            searchText: textSizeUtils.searchText,
            startText: locales.getCaption('searchText', 'other'),
            startTextAbp: locales.getCaption('searchTextAbp', 'other'),
            isLoading: false,
            noHits: false,
            myVideos: [],
            titleWidth: this.getMaximumTitleWidth()
        };
    },
    getMaximumTitleWidth() {
        var maxim = textSizeUtils.getSpanWidth(15, locales.getCaption('SearchAll', 'other'));

        maxim = Math.max(maxim, textSizeUtils.getSpanWidth(15, locales.getCaption('SearchProps', 'other')));
        maxim = Math.max(maxim, textSizeUtils.getSpanWidth(15, locales.getCaption('SearchCharacters', 'other')));
        maxim = Math.max(maxim, textSizeUtils.getSpanWidth(15, locales.getCaption('SearchBackgrounds', 'other')));
        maxim = Math.max(maxim, textSizeUtils.getSpanWidth(15, locales.getCaption('SearchFrames', 'other')));
        maxim = Math.max(maxim, textSizeUtils.getSpanWidth(15, locales.getCaption('SearchEffects', 'other')));
        maxim = Math.max(maxim, textSizeUtils.getSpanWidth(15, locales.getCaption('SearchThemes', 'other')));
        maxim = Math.max(maxim, textSizeUtils.getSpanWidth(15, locales.getCaption('SearchMyImages', 'other')));
        maxim = Math.max(maxim, textSizeUtils.getSpanWidth(15, locales.getCaption('SearchMyVideos', 'other')));
        maxim = Math.max(maxim, textSizeUtils.getSpanWidth(15, locales.getCaption('SearchThemeVideos')));
        maxim = Math.max(maxim, textSizeUtils.getSpanWidth(15, locales.getCaption('SearchAudios', 'other')));

        return maxim;
    },
    componentDidMount() {
        this.ensureMyMediaFilesIsLoaded();
        this.loadMyFramesTheme();

        var isApiSearch = (this.props.cartoonistTabIndex == 1 || this.props.cartoonistTabIndex == 2 || this.props.cartoonistTabIndex == 3 || this.props.cartoonistTabIndex == 9 || this.isAbpUniverse());

        if (isApiSearch) // if it's all and no search then don't show items, otherwise (backgrounds, props, characters, clipart videos) should search for all these items
            this.performSearch();
        else {
            if (textSizeUtils.searchText != '')
                this.performSearch();
        }
    },
    componentWillReceiveProps: function(nextProps) {
        if (nextProps.contextMode === modeType.SEARCH_CONTEXT && this.props.contextMode != nextProps.contextMode)
            this.startAnimation();

        if (nextProps.contextMode === modeType.SEARCH_CONTEXT && this.props.showVideoEditor !== nextProps.showVideoEditor && nextProps.showVideoEditor === false)
            this.startAnimation();

        var doSearch = false;

        if (this.isAbpUniverse() && this.props.contextMode != nextProps.contextMode && nextProps.contextMode == modeType.SEARCH_CONTEXT && this.state.dataProvider && this.state.dataProvider.length == 0)
            doSearch = true;

        if (this.props.cartoonistTabIndex != nextProps.cartoonistTabIndex || this.props.mediaFilesDataProvider != nextProps.mediaFilesDataProvider || doSearch) {
            this.setState({
                dataProvider: [],
                noHits: false
            });

            setTimeout(function() {
                this.performSearch();
            }.bind(this), 10);
        }

        if (this.props.contextMode == modeType.SEARCH_CONTEXT && nextProps.contextMode != modeType.SEARCH_CONTEXT)
            this.clearSearch();
    },
    ensureMyMediaFilesIsLoaded() {
        const state = storeManager.getState();
        const mediaFilesDataProvider = state.accordion.mediaFilesDataProvider;

        if (!mediaFilesDataProvider && !configuration.LOAD_LOCAL) {
            apiServiceUtils.executeSafeApiCall(this.loadMyMediaFiles.bind(this));
        }
    },
    loadMyFramesTheme() {
        if (configuration.LOAD_LOCAL)
            return;

        if (clipartParserJSONNew.frames)
            return;

        apiServiceUtils.executeSafeApiCall(function() {
            apiService.loadCurrentTheme('frames').then(response => {
                clipartParserJSONNew.parseClipartModel(response, false, '', true);
            });
        }.bind(this));
    },
    loadMyMediaFiles() {
        apiServiceUtils.executeGetMediaFilesCall(this.parseMediaItems.bind(this));
    },
    parseMediaItems (items) {
        populateMediaFilesUtils.parseMediaItems(items, storeManager.getStore().dispatch);
    },
    onMouseIn () {
        this.setState({
            isOver: true
        });
    },
    onMouseOut () {
        this.setState({
            isOver: false
        });
    },
    changeFocus() {
        var view = this.refs.searchInput;

        if (view) {
            view.focus();

            if (view.value && view.value.length > 0)
                view.select();
        }
    },
    onInputClick(e) {
        if (this.refs.searchInput && textSizeUtils.searchText != '' && this.refs.searchInput.value != textSizeUtils.searchText) {
            this.refs.searchInput.value = textSizeUtils.searchText;
            this.performSearch();
        } else {
            if (this.isAbpUniverse())
                this.performSearch();
        }

        this.changeFocus();

        this.props.dispatch(changeContextMode(modeType.SEARCH_CONTEXT));
    },
    onChangeText() {
        if (textSizeUtils.searchText == '' || this.refs.searchInput.value == '') {
            textSizeUtils.searchText = this.refs.searchInput.value;

            this.forceUpdate();
        } else
            textSizeUtils.searchText = this.refs.searchInput.value;

        if (this.props.contextMode != modeType.SEARCH_CONTEXT) {
            this.props.dispatch(changeContextMode(modeType.SEARCH_CONTEXT));

            setTimeout(function() {
                this.performSearch(true);
            }.bind(this), 10);
        } else
            this.performSearch(true);
    },
    getSounds() {
        const clipartModel = storeManager.getState().music.soundClipartModel;

        if (!clipartModel)
            return [];

        var i, j, k;
        var mainItems = clipartModel.items;
        var searchText = this.refs.searchInput.value.toLowerCase();
        var array = [];
        var title;

        for (i=0; i<mainItems.length; i++) {
            var secondItems = mainItems[i].items;

            for (j=0; j<secondItems.length; j++) {
                var finalItems = secondItems[j].items;

                for (k=0; k<finalItems.length; k++) {
                    var element = finalItems[k];
                    title = element.title.toLowerCase();

                    if (title.indexOf(searchText) != -1)
                        array.push(element);
                }
            }
        }

        const state = storeManager.getState();
        const mediaFilesDataProvider = state.accordion.mediaFilesDataProvider;

        if (mediaFilesDataProvider) {
            var mySounds = mediaFilesDataProvider.soundsDataProvider;

            for (i=0; i<mySounds.length; i++) {
                if (mySounds && mySounds[i] && mySounds[i].title) {
                    title = mySounds[i].title.toLowerCase();

                    if (title.indexOf(searchText) != -1)
                        array.push(mySounds[i]);
                }

            }
        }

        return array;
    },
    filterContent(array, isThemes = false) {
        if (!this.refs.searchInput || this.refs.searchInput.value == '' || this.refs.searchInput.value == undefined)
            return array;
        else {
            var searchText = this.refs.searchInput.value.toLowerCase();
            var newArray = [];

            for (var i=0; i<array.length; i++) {
                var title = isThemes ? this.getTitle(array[i]).toLowerCase() : array[i].title.toLowerCase();

                if (title.indexOf(searchText) != -1)
                    newArray.push(array[i]);
            }

            return newArray;
        }
    },
    getThemes() {
        var array = masterUniverseUtils.getAllThemes();

        return this.filterContent(array, true);
    },
    getEffects() {
        if (!clipartParserJSONNew.cartoonistEffects)
            return [];

        var array = clipartParserJSONNew.cartoonistEffects.items;

        return this.filterContent(array);
    },
    getFrames() {
        if (!clipartParserJSONNew.frames)
            return [];

        var array = clipartParserJSONNew.frames.items;

        return this.filterContent(array);
    },
    getMyImages() {
        const mediaFilesDataProvider = storeManager.getState().accordion.mediaFilesDataProvider;

        if (!mediaFilesDataProvider || !mediaFilesDataProvider.imagesDataProvider) {
            this.ensureMyMediaFilesIsLoaded();
            return [];
        }

        var array = mediaFilesDataProvider.imagesDataProvider;

        return this.filterContent(array);
    },
    getMyVideos() {
        const mediaFilesDataProvider = storeManager.getState().accordion.mediaFilesDataProvider;

        if (!mediaFilesDataProvider || !mediaFilesDataProvider.videosDataProvider) {
            this.ensureMyMediaFilesIsLoaded();
            return [];
        }

        var array = mediaFilesDataProvider.videosDataProvider;

        return this.filterContent(array);
    },
    getTitle(item) {
        if (!item.translations)
            return item.name;
        else {
            var translation = item.translations[masterUniverseUtils.language()];

            if (translation && translation.length > 0)
                return translation;
            else if (item.translations['en_US'])
                return item.translations['en_US'];
            else
                return item.name;
        }
    },
    doSearch(isKeyboardEvent = false) {
        this.setState({
            isLoading: true
        });

        if (isKeyboardEvent) {
            populateMediaFilesUtils.searchTime = new Date().getTime();

            setTimeout(this.doSearchTimeout.bind(this), 2000);
        } else {
            this.executeSearchContentCall();
        }
    },
    doSearchTimeout() {
        var currentTime = new Date().getTime();

        if ((currentTime - populateMediaFilesUtils.searchTime) >= 2000) {
            this.executeSearchContentCall();
        }
    },
    performSearch(isKeyboardEvent = false) {
        if (configuration.LOAD_LOCAL) {
            if(this.props.cartoonistTabIndex == 8)
                this.setState({
                    dataProvider: populateMediaFilesUtils.getVideosDataProviderForTest()
                });
            else
                this.setState({
                    dataProvider: populateMediaFilesUtils.getImagesDataProviderForTest()
                });

            return;
        }

        if (this.isAbpUniverse()) {
            this.doSearch(isKeyboardEvent); // do search for abp content
            return;
        }

        var noHitsValue = false;
        var dataProvider;

        if (this.isAudioTool()) {
            dataProvider = this.getSounds();

            if (!dataProvider || dataProvider.length < 1)
                noHitsValue = true;

            this.setState({
                dataProvider,
                noHits: noHitsValue
            });

            return;
        }

        switch (true) {
            case (this.props.cartoonistTabIndex == 4): {
                dataProvider = this.getFrames();
                break;
            }
            case (this.props.cartoonistTabIndex == 5): {
                dataProvider = this.getEffects();
                break;
            }
            case (this.props.cartoonistTabIndex == 6): {
                dataProvider = this.getThemes();
                break;
            }
            case (this.props.cartoonistTabIndex == 7): {
                dataProvider = this.getMyImages();
                break;
            }
            case (this.props.cartoonistTabIndex == 8): { // My videos
                dataProvider = this.getMyVideos();
                break;
            }
            case (this.props.cartoonistTabIndex == 9): { // Clipart Video
                // search for Video Clipart content ... here is needed for a search
                break;
            }
            case (this.props.cartoonistTabIndex == 10): {
                dataProvider = this.getSounds();
                break;
            }
        }

        if (this.props.cartoonistTabIndex >= 4 && this.props.cartoonistTabIndex != 9) { // no api call search is needed
            if (!dataProvider || dataProvider.length < 1)
                noHitsValue = true;

            this.setState({
                dataProvider,
                noHits: noHitsValue
            });

            return;
        }

        var isVideoClipart = this.props.cartoonistTabIndex == 9;

        if (!isVideoClipart) {
            var isApiSearch = (this.props.cartoonistTabIndex == 1 || this.props.cartoonistTabIndex == 2 || this.props.cartoonistTabIndex == 3);

            if (!isApiSearch) { // if it's all category and no search on api then don't show items, otherwise (backgrounds, props, characters) show all items
                if (!this.isSearchMode()) {
                    setTimeout(function () {
                        this.setState({
                            dataProvider: [],
                            noHits: false
                        });
                    }.bind(this), 50);

                    return;
                }
            }
        }

        if (configuration.LOAD_LOCAL) {
            this.setState({
                dataProvider: []
            });
        } else {
            this.doSearch(isKeyboardEvent); // do search for backgrounds, props, characters and videos (clipart videos) and abp content
        }
    },
    executeSearchContentCall() {
        var searchValue = '';

        if (this.refs.searchInput && this.refs.searchInput.value.length > 0)
            searchValue = this.refs.searchInput.value;

        var isVideo = this.props.cartoonistTabIndex == 9;
        var locale = appParameters.locale;
        var pageSize = 50;
        var searchObject = {};

        if (isVideo) {
            apiService.searchVideo(locale, searchValue, 0, pageSize)
                .then(response => {
                    searchObject.locale = locale;
                    searchObject.searchText = searchValue;
                    searchObject.pageSize = pageSize;

                    if (!response || response.length < 1) {
                        this.setState({
                            dataProvider: [],
                            isLoading: false,
                            noHits: true
                        });
                    } else {
                        this.setState({
                            dataProvider: videoClipartParserJSON.parseSearchItems(response),
                            isLoading: false,
                            noHits: false,
                            searchObject: searchObject
                        });
                    }
                });
        } else {
            var category = 'all';

            if (this.props.cartoonistTabIndex == 3)
                category = 'backgrounds';
            else if (this.props.cartoonistTabIndex == 2)
                category = 'characters';
            else if (this.props.cartoonistTabIndex == 1)
                category = 'props';

            if (this.isAbpUniverse())
                category = 'abp';
            else {
                if (this.props.cartoonistTabIndex >= 4)
                    return;
            }

            apiService.searchNewContent(locale, category, searchValue, 0, pageSize)
                .then(response => {
                    searchObject.locale = locale;
                    searchObject.category = category;
                    searchObject.searchText = searchValue;
                    searchObject.pageSize = pageSize;

                    if (!response || response.length < 1) {
                        this.setState({
                            dataProvider: [],
                            isLoading: false,
                            noHits: true
                        });
                    } else {
                        this.setState({
                            dataProvider: clipartParserJSONNew.parseSearchItems(response, category),
                            isLoading: false,
                            noHits: false,
                            searchObject: searchObject
                        });
                    }
                });
        }
    },
    clearSearch() {
        setTimeout(function() {
            if (this.refs.searchInput)
                this.refs.searchInput.value = '';

            this.forceUpdate();
        }.bind(this), 20);
    },
    isSearchMode() {
        if (this.refs.searchInput && this.refs.searchInput.value.length > 0)
            return true;
        else
            return false;
    },
    isAudioTool() {
        return audioToolUtils.isAudioTool();
    },
    startAnimation() {
        if (this.isAudioTool())
            return;

        this.stopAnimation();

        var animationTimer = setInterval(this.animationStep, 50);

        this.setState({
            animationTimer
        });
    },
    animationStep() {
        if (this.isAudioTool())
            return;

        var cartoonistMenu = this.refs.cartoonistMenu;

        if (cartoonistMenu) {
            var cartoonistMenuWidth = 200;

            if (this.state.titleWidth > 0) {
                cartoonistMenuWidth = 40 + this.state.titleWidth + 10;
            }

            var maxLeft = - cartoonistMenuWidth;
            var step = 50;
            var leftPos = cartoonistMenu.style.left.replace('px', '');
            var newPos = leftPos - step;

            if (newPos <= maxLeft) {
                this.stopAnimation();
                newPos = maxLeft;
            }

            cartoonistMenu.style.left = newPos + 'px';
        }
    },
    stopAnimation() {
        if (this.isAudioTool())
            return;

        if (this.state.animationTimer)
            clearInterval(this.state.animationTimer);
    },
    getTitleBarCaption(index) {
        var title = '';

        if (this.isAbpUniverse())
            return locales.getCaption('SearchAll', 'other');

        switch (index) {
            case 0: {
                title = locales.getCaption('SearchAll', 'other');
                break;
            }
            case 1: {
                title = locales.getCaption('SearchProps', 'other');
                break;
            }
            case 2: {
                title = locales.getCaption('SearchCharacters', 'other');
                break;
            }
            case 3: {
                title = locales.getCaption('SearchBackgrounds', 'other');
                break;
            }
            case 4: {
                title = locales.getCaption('SearchFrames', 'other');
                break;
            }
            case 5: {
                title = locales.getCaption('SearchEffects', 'other');
                break;
            }
            case 6: {
                title = locales.getCaption('SearchThemes', 'other');
                break;
            }
            case 7: {
                title = locales.getCaption('SearchMyImages', 'other');
                break;
            }
            case 8: {
                title = locales.getCaption('SearchMyVideos', 'other');
                break;
            }
            case 9: {
                title = locales.getCaption('SearchThemeVideos');
                break;
            }
            case 10: {
                title = locales.getCaption('SearchAudios', 'other');
                break;
            }
        }

        return title;
    },
    onCloseClick(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        const dispatch = storeManager.getStore().dispatch;

        dispatch(changeContextMode(modeType.CONTEXT_NONE));
        mindMapUtils.reset();
    },
    isAbpUniverse() {
        if (appParameters.currentMainUniverse == 'alphabet_planet') {
            if (this.props.clipartCategory == 0) {
                if (moodsUtils.previewContextMenu == modeType.CONTEXT_NONE)
                    return true;
                else
                    return false;
            } else
                return false;
        } else
            return false;
    },
    onDeleteClick(e) {
        if (e.clientX && e.clientY) {
            const windowWidth = window.innerWidth;
            const rightOffset = 15;
            const buttonSize = 15;
            const topOffset = 9;

            if (e.clientX >= (windowWidth - rightOffset - buttonSize) && e.clientX <= (windowWidth - rightOffset) && e.clientY >= topOffset && e.clientY <= (topOffset + buttonSize)) {
                textSizeUtils.searchText = '';
                this.refs.searchInput.value = '';

                this.setState({
                    dataProvider: [],
                    noHits: false
                });

                this.performSearch(false);
            }
        }
    },
    render() {
        var isIOS = platformDetection.isIOS();

        var clipartButtonHeight = properties.SEARCH_HEIGHT();
        var menuStyle = {
            position: 'absolute',
            top: apiServiceUtils.getNoInternetConnectionAlertHeight(),
            right: 0,
            width: this.props.accordionWidth,
            height: clipartButtonHeight,
            overflow: 'visible',
            backgroundColor: 'white',
            userSelect: 'none',
            WebkitUserSelect: 'none',
            zIndex: 15000
        };

        /*********************** search ******************************/

        var borderColor;
        var textColor;
        var inputValue = '';

        if (this.refs.searchInput && this.refs.searchInput.value)
            inputValue = this.refs.searchInput.value;

        if (this.state.isOver == true) {
            borderColor = properties.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
            textColor = borderColor;
        } else {
            borderColor = 'black';
            textColor = 'black';
        }

        var fontSize = 16;
        var leftGap = 5;
        var inputPadding = 5;

        if (isIOS) {
            leftGap = 4;
            fontSize = 14;
            inputPadding = 10;
        }

        var titleWidth = this.props.accordionWidth - 2 * leftGap;

        var titleStyle = {
            width: titleWidth,
            height: 21,
            position: 'absolute',
            left: leftGap,
            top: 5,
            alignItems: 'center'
        };

        var labelWidth = 55;
        var searchValue = locales.getCaption('searchLabel', 'other');

        if (appParameters.locale.indexOf('NO') != -1)
            labelWidth = 35;

        var searchLabelStyle = {
            color: 'black',
            top: 0,
            left: 0,
            fontSize: fontSize,
            width: labelWidth,
            resize: 'none',
            overflow: 'hidden',
            border: 'none',
            background: 'transparent',
            display: 'inline-block',
            marginTop: 1
        };

        var inputStyle = {
            position: 'absolute',
            color: textColor,
            top: -1,
            paddingLeft: inputPadding,
            fontSize: fontSize,
            width: titleWidth - inputPadding - labelWidth,
            resize: 'none',
            overflow: 'hidden',
            background: 'transparent',
            borderStyle: 'solid',
            borderWidth: 1,
            borderColor: '#777777',
            borderRadius: 5
        };

        if (isIOS) {
            titleStyle.top = 9;
            titleStyle.borderStyle = 'hidden';

            searchLabelStyle.fontSize = 15;
            inputStyle.fontSize = 15;
            inputStyle.width = inputStyle.width + 10;
            inputStyle.top = 0;
        }

        var lineStyle = {
            position: 'absolute',
            top: clipartButtonHeight,
            width: '100%',
            height: 1,
            backgroundColor: '#434343',
            display: this.props.contextMode == modeType.SEARCH_CONTEXT ? 'block' : 'none'
        };

        var startTextValue = this.state.startText;

        if (this.isAbpUniverse())
            startTextValue = this.state.startTextAbp;

        var searchElement =
            <div>
                <div role='search' id='searchInputField' style={titleStyle} className='titleInput' onMouseOver={this.onMouseIn} onMouseOut={this.onMouseOut} onTouchEnd={this.onInputClick} onClick={this.onInputClick}>
                    <label htmlFor='searchInputElement' style={searchLabelStyle}>{searchValue}</label>
                    <input placeholder={startTextValue} type='search' ref='searchInput' id='searchInputElement' onClick={this.onDeleteClick} defaultValue={this.state.searchText} className='titleInput' style={inputStyle} spellCheck='false' autoCorrect='off' autoCapitalize='off' autoComplete='off' onChange={this.onChangeText}/>
                </div>

                <div style={lineStyle}></div>
            </div>;

        if (this.props.contextMode != modeType.SEARCH_CONTEXT) {
            return (
                <div style={menuStyle}>
                    {searchElement}
                </div>
            );
        }
        /*********************** title bar ******************************/

        var titleBar;

        const titleBarStyle = {
            position: 'absolute',
            backgroundColor: properties.BROWSER_SELECTED_COLOR,
            width: this.props.accordionWidth,
            height: properties.CLIPART_BUTTON_HEIGHT,
            display: 'flex',
            alignItems: 'center',
            paddingLeft: 20,
            top: clipartButtonHeight
        };

        const titleBarSpanStyle = {
            color: 'white',
            fontSize: 16,
            cursor: 'default',
            position: 'absolute',
            top: 6
        };

        var caption = this.getTitleBarCaption(this.props.cartoonistTabIndex);

        var closeButtonStyle = {
            position: 'absolute',
            right: 28,
            top: 4,
            width: titleStyle.height,
            height: titleStyle.height,
            cursor: 'pointer',
            userDrag: 'none',
            WebkitUserSelect: 'none',
            userSelect: 'none',
            background: 'none',
            borderStyle: 'none',
            margin: 0,
            padding: 0,
            boxSizing: 'initial',
            fontSize: 'initial'
        };

        const closeStyle = {
            position: 'absolute',
            width: 15,
            top: 3,
            right: 3,
            cursor: 'pointer'
        };

        titleBar =
            <div style={titleBarStyle}>
                <span style={titleBarSpanStyle}>{caption}</span>
                <button id="closeButton" style={closeButtonStyle} aria-label={locales.getCaption('close', 'other')} onClick={this.onCloseClick} onTouchEnd={this.onCloseClick}>
                    <img alt='' aria-hidden='true' style={closeStyle} src={appParameters.RESOURCES_LOCATION() + 'assets/exit_edit.png'}/>
                </button>
            </div>;

        /*********************** accordion and list ******************************/

        menuStyle.height = this.props.windowHeight;

        var holderHeight = this.props.windowHeight;
        var listTopPosition;
        var listTopGap = 10;
        var listBottomGap = 5;
        var listElement;
        var audioTab;
        var cartoonistMenuWidth = 200;
        var searchMenu;

        if (this.state.titleWidth > 0) {
            cartoonistMenuWidth = 40 + this.state.titleWidth + 10;
        }

        if (!this.isAudioTool() && !this.isAbpUniverse()) {
            var cartoonistMenuStyle = {
                position: 'absolute',
                left: 0,
                top: 0,
                height: holderHeight,
                width: cartoonistMenuWidth,
                background: 'white',
                zIndex: 1000,
                borderRightColor: 'black',
                borderRightStyle: 'solid',
                borderRightWidth: 1,
                boxShadow: '-2px 0px 8px'
            };

            if (videoUtils.showVideoEditor()) {
                // don't show menu
            } else {
                if (mindMapUtils.isMindMapMode()) {
                    searchMenu = <div style={cartoonistMenuStyle} ref='cartoonistMenu'>
                        <CartoonistTabElement width={cartoonistMenuWidth} index={0} cartoonistTabIndex={this.props.cartoonistTabIndex}/>
                        <CartoonistTabElement width={cartoonistMenuWidth} index={1} cartoonistTabIndex={this.props.cartoonistTabIndex}/>
                        <CartoonistTabElement width={cartoonistMenuWidth} index={2} cartoonistTabIndex={this.props.cartoonistTabIndex}/>
                        <CartoonistTabElement width={cartoonistMenuWidth} index={3} cartoonistTabIndex={this.props.cartoonistTabIndex}/>
                        <CartoonistTabElement width={cartoonistMenuWidth} index={4} cartoonistTabIndex={this.props.cartoonistTabIndex}/>
                    </div>;
                } else {
                    searchMenu = <div style={cartoonistMenuStyle} ref='cartoonistMenu'>
                        <CartoonistTabElement width={cartoonistMenuWidth} index={0} cartoonistTabIndex={this.props.cartoonistTabIndex}/>
                        <CartoonistTabElement width={cartoonistMenuWidth} index={1} cartoonistTabIndex={this.props.cartoonistTabIndex}/>
                        <CartoonistTabElement width={cartoonistMenuWidth} index={2} cartoonistTabIndex={this.props.cartoonistTabIndex}/>
                        <CartoonistTabElement width={cartoonistMenuWidth} index={3} cartoonistTabIndex={this.props.cartoonistTabIndex}/>
                        <CartoonistTabElement width={cartoonistMenuWidth} index={4} cartoonistTabIndex={this.props.cartoonistTabIndex}/>
                        <CartoonistTabElement width={cartoonistMenuWidth} index={5} cartoonistTabIndex={this.props.cartoonistTabIndex}/>
                        <CartoonistTabElement width={cartoonistMenuWidth} index={6} cartoonistTabIndex={this.props.cartoonistTabIndex}/>
                        <CartoonistTabElement width={cartoonistMenuWidth} index={7} cartoonistTabIndex={this.props.cartoonistTabIndex}/>
                        <CartoonistTabElement width={cartoonistMenuWidth} index={8} cartoonistTabIndex={this.props.cartoonistTabIndex}/>
                        <CartoonistTabElement width={cartoonistMenuWidth} index={9} cartoonistTabIndex={this.props.cartoonistTabIndex}/>
                        <CartoonistTabElement width={cartoonistMenuWidth} index={10} cartoonistTabIndex={this.props.cartoonistTabIndex}/>
                    </div>;
                }
            }

            listTopPosition = clipartButtonHeight + listTopGap;
        }

        var titleBarHeight = properties.CLIPART_BUTTON_HEIGHT;

        listTopPosition = listTopPosition + titleBarHeight;

        if (this.isAudioTool() || this.props.cartoonistTabIndex == 10) { // audios list
            var accordionStyle = {
                position: 'absolute',
                left: 0,
                top: clipartButtonHeight + titleBarHeight
            };

            var isMediaSound = false;

            if (playController.isAudioEditorAvailable()) {
                listTopPosition = clipartButtonHeight + listTopGap;
            } else {
                audioTab = <div style={accordionStyle}>
                    <AudioTabElement accordionWidth={this.props.accordionWidth} index={0} audioTabIndex={this.props.audioTabIndex}/>
                    <AudioTabElement accordionWidth={this.props.accordionWidth} index={1} audioTabIndex={this.props.audioTabIndex}/>
                </div>;

                listTopPosition = clipartButtonHeight + 2 * properties.BROWSER_BUTTON_HEIGHT + listTopGap;

                if (this.props.audioTabIndex == 1)
                    isMediaSound = true;
            }

            listTopPosition = listTopPosition + titleBarHeight;

            listElement = <AudioList accordionWidth={this.props.accordionWidth} isSearch={this.isSearchMode()} noHits={this.state.noHits} isMediaSound={isMediaSound} top={listTopPosition} width={this.props.accordionWidth} height={holderHeight - listTopPosition - listBottomGap} windowHeight={this.props.windowHeight} dispatch={this.props.dispatch} dataProvider={this.state.dataProvider}/>;
        } else if (this.isAbpUniverse()) { // abp
            listTopPosition = clipartButtonHeight + titleBarHeight + listTopGap;

            listElement = <ClipartList isBackgroundList={true} dispatch={this.props.dispatch} searchObject={this.state.searchObject} isSearch={this.isSearchMode()} noHits={this.state.noHits} isLoading={this.state.isLoading} useBackgroundAsImage={this.props.useBackgroundAsImage} dataProvider={this.state.dataProvider} width={this.props.accordionWidth} top={listTopPosition} height={holderHeight - listTopPosition - listBottomGap}/>;
        } else if (this.props.cartoonistTabIndex == 6) // themes list
            listElement = <ClipartSelectorListNew dataProvider={this.state.dataProvider} isSearch={true} noHits={this.state.noHits} dispatch={this.props.dispatch} accordionWidth={this.props.accordionWidth} windowHeight={this.props.windowHeight} isUniversesVisible={true} topOffset={titleBarHeight}/>;
        else if (this.props.cartoonistTabIndex == 9) { // VideoCliparts
            listElement = <VideoThemesList dispatch={this.props.dispatch} isLoading={this.state.isLoading} noHits={this.state.noHits} searchObject={this.state.searchObject} isSearch={this.isSearchMode()} dataProvider={this.state.dataProvider} width={this.props.accordionWidth} useVideoAsBackground={this.props.useVideoAsBackground} top={listTopPosition} height={holderHeight - listTopPosition - listBottomGap}/>;
        } else if (this.props.cartoonistTabIndex == 4 || this.props.cartoonistTabIndex == 5 || this.props.cartoonistTabIndex == 7 || this.props.cartoonistTabIndex == 8) { // effects, frames, MyImages, MyVideos
            listElement = <MediaList isMyMedia={this.props.cartoonistTabIndex == 7 || this.props.cartoonistTabIndex == 8} isBackgroundList={this.props.cartoonistTabIndex == 4 || this.props.cartoonistTabIndex == 7 || this.props.cartoonistTabIndex == 8} dispatch={this.props.dispatch} isBackground={this.props.cartoonistTabIndex == 4 || this.props.cartoonistTabIndex == 7} isFrame={this.props.cartoonistTabIndex == 4} isMedia={this.props.cartoonistTabIndex == 7 || this.props.cartoonistTabIndex == 8} isVideo={this.props.cartoonistTabIndex == 8} useFrameAsImage={this.props.useFrameAsImage} useImageAsBackground={this.props.useImageAsBackground} useVideoAsBackground={this.props.useVideoAsBackground} isLoading={this.state.isLoading} noHits={this.state.noHits} isSearch={this.isSearchMode()} dataProvider={this.state.dataProvider} width={this.props.accordionWidth} top={listTopPosition} height={holderHeight - listTopPosition - listBottomGap}/>;
        } else { // all content, backgrounds, characters, props
            listElement = <ClipartList isBackgroundList={this.props.cartoonistTabIndex == 0 || this.props.cartoonistTabIndex == 3} dispatch={this.props.dispatch} searchObject={this.state.searchObject} isSearch={this.isSearchMode()} noHits={this.state.noHits} isLoading={this.state.isLoading} useBackgroundAsImage={this.props.useBackgroundAsImage} dataProvider={this.state.dataProvider} width={this.props.accordionWidth} top={listTopPosition} height={holderHeight - listTopPosition - listBottomGap}/>;
        }

        return (
            <div style={menuStyle}>
                {searchElement}
                {titleBar}
                {audioTab}
                {listElement}
                {searchMenu}
            </div>
        );
    }
});

function mapStateToProps () {
    const state = storeManager.getState();
    const contextMode = state.menu.contextMode;
    var accordionWidth = state.accordion.width;
    var audioTabIndex = state.menu.audioTabIndex;
    var cartoonistTabIndex = state.menu.cartoonistTabIndex;
    var useBackgroundAsImage = state.menu.useBackgroundAsImage;
    var useFrameAsImage = state.menu.useFrameAsImage;
    var useImageAsBackground = state.menu.useImageAsBackground;
    var mediaFilesDataProvider = state.accordion.mediaFilesDataProvider;
    var showVideoEditor = state.menu.showVideoEditor;
    var clipartCategory = state.menu.clipartCategory;
    var useVideoAsBackground = state.menu.useVideoAsBackground;

    if (showVideoEditor == undefined)
        showVideoEditor = false;

    if (useBackgroundAsImage == undefined)
        useBackgroundAsImage = false;

    if (useFrameAsImage == undefined)
        useFrameAsImage = false;

    if (useVideoAsBackground == undefined)
        useVideoAsBackground = true;

    if (useImageAsBackground == undefined)
        useImageAsBackground = false;

    if (accordionWidth == undefined)
        accordionWidth = properties.BROWSER_WIDTH;

    if (audioTabIndex == undefined)
        audioTabIndex = 0;

    if (cartoonistTabIndex == undefined)
        cartoonistTabIndex = 0;

    if (clipartCategory == undefined)
        clipartCategory = 0;

    return {
        accordionWidth,
        contextMode,
        audioTabIndex,
        cartoonistTabIndex,
        useBackgroundAsImage,
        useFrameAsImage,
        useImageAsBackground,
        mediaFilesDataProvider,
        showVideoEditor,
        clipartCategory,
        useVideoAsBackground
    };
}

export const SearchMenu = connect(mapStateToProps)(SearchMenuContent);


/** WEBPACK FOOTER **
 ** ./src/components/menus/SearchMenu.js
 **/